<template>
  <v-navigation-drawer
    permanent
    absolute
    expand-on-hover
    dark
    :close-delay="500"
    class="asc-primary-navbar--container"
    :mini-variant-width="48"
    :mini-variant.sync="isCollapsed"
    @update:mini-variant="handleMiniVariantUpdate"
  >
    <div class="asc-primary-navbar--gear-logo-container">
      <div v-show="isCollapsed">
        <img alt="logoGear" class="asc-primary-navbar--gear" :src="rotorLogo" />
        <div class="asc-primary-navbar--gear"></div>
      </div>
      <div v-show="!isCollapsed">
        <img alt="logo" class="asc-primary-navbar--logo" :src="collinsLogo" />
      </div>
    </div>
    <v-list
      class="pa-0 asc-nav-list"
      :class="[isCollapsed ? 'asc-nav-list--collapsed' : '']"
    >
      <v-list-item
        v-if="validateRoles([roleEnum.airlineUser])"
        link
        to="/"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-home</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize">Home</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="validateRoles([roleEnum.airlineUser, roleEnum.acmfUser])"
        link
        to="/fleet"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-airplane</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Fleet
          <span
            v-if="
              (validatePermissions([aogPermission]) && aogOn) ||
              (validatePermissions([fleetMonitoringPermission]) &&
                fleetMonitoringOn)
            "
            class="legacy_text"
            >(Legacy)</span
          ></v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-if="aogOn && validatePermissions([aogPermission])"
        link
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
        :href="createExternalRoute('fleet-management')"
        @click="handleVue3Click(createExternalRoute('fleet-management'))"
      >
        <v-list-item-icon>
          <v-icon>mdi-airplane</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Fleet Management</v-list-item-title
        >
      </v-list-item>

      <v-list-item
        v-if="
          fleetMonitoringOn && validatePermissions([fleetMonitoringPermission])
        "
        link
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
        :href="createExternalRoute('fleet-monitoring')"
        @click="handleVue3Click(createExternalRoute('fleet-monitoring'))"
      >
        <v-list-item-icon>
          <v-icon>mdi-alert</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Fleet Monitoring</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-if="validateRoles([roleEnum.acmfUser])"
        link
        to="/reports"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-file</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize">Reports</v-list-item-title>
      </v-list-item>

      <v-list-item
        link
        to="/dashboards"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-collage</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Dashboards</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        link
        to="/flight-data"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-equalizer</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Flight Data</v-list-item-title
        >
      </v-list-item>
      <v-list-item
        v-if="validatePermissions([maintenanceData])"
        key="maintenancedata"
        to="/maintenance-data"
        :color="getHighLightColor"
        link
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
        ><v-list-item-icon>
          <v-icon>mdi mdi-wrench</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-capitalize">
            Maintenance Data
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="validatePermissions([mxRecPermission])"
        link
        to="/maintenance"
        :color="getHighLightColor"
        class="asc-nav-list-item"
        active-class="asc-nav-list-item--active"
      >
        <v-list-item-icon>
          <v-icon>mdi-alert-circle</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="text-capitalize"
          >Maintenance Issues</v-list-item-title
        >
      </v-list-item>
      <v-list-group
        prepend-icon="mdi-chart-timeline-variant"
        no-action
        :color="getHighLightColor"
        :group="analyticsGroupMatchRegex"
        :active="analyticsActive"
      >
        <template #activator>
          <v-list-item-content>
            <v-list-item-title class="text-capitalize"
              >Analytics</v-list-item-title
            >
          </v-list-item-content>
        </template>
        <v-list-item
          key="custom-analytics"
          to="/custom-analytics"
          :color="getHighLightColor"
          link
          class="asc-nav-list-item"
          active-class="asc-nav-list-item--active"
        >
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              Custom Analytics
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="validateRoles([roleEnum.anserUser])"
          key="analytics-developer"
          to="/analytics-developer"
          :color="getHighLightColor"
          link
          class="asc-nav-list-item"
          active-class="asc-nav-list-item--active"
        >
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              Analytics Developer
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="validateRoles([roleEnum.airlineUser])"
          key="custom-parameters"
          to="/custom-parameters"
          :color="getHighLightColor"
          link
          class="asc-nav-list-item"
          active-class="asc-nav-list-item--active"
        >
          <v-list-item-content>
            <v-list-item-title class="text-capitalize">
              Custom Parameters
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          key="ascentia-analytics"
          to="/ascentia-analytics"
          :color="getHighLightColor"
          link
          class="asc-nav-list-item"
          active-class="asc-nav-list-item--active"
        >
          <v-list-item-content>
            <v-list-item-title
              class="text-capitalize"
              style="line-height: 1.3"
              v-html="ascentiaAnalyticsTitle"
            >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import variables from '@/styles/_varsJs.scss'
import {
  FULL_FLIGHT_TIER_2,
  COLLINS_PHM_TIER_3,
  COLLINS_PHM_TIER_4,
  ROLE_CONSTS,
  PERMISSION_CONSTS,
} from '@/utilities/appConsts'
import { PERMISSION_LEVEL_CONSTS as PLC } from '@/stores/consts'
import { PERMISSION_LEVEL_CONSTS, RESOURCES } from '@/utilities/appConsts'
import collinsLogo from '@/assets/collins_new_logo.png'
import rotorLogo from '@/assets/rotor.png'

export default {
  name: 'AscPrimaryNavbar',
  props: {
    collapsed: {
      type: Boolean,
      default: true,
    },
    onSizeChange: {
      type: Function,
      required: true,
    },
    featureFlags: {
      type: Object,
      default: () => {},
    },
    router: {
      type: Object,
      default: () => {},
    },
    userRoles: {
      type: Array,
      default: () => [],
    },
    userPermissions: {
      type: Array,
      default: () => [],
    },
    userAirlines: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      index: '',
      isCollapsed: this.collapsed,
      ascentiaAnalyticsTitle: 'Ascentia<sup>&reg;</sup> Analytics',
      analyticRoutes: [
        '/custom-analytics',
        '/analytics-developer',
        '/custom-parameters',
        '/ascentia-analytics',
      ],
      roleEnum: ROLE_CONSTS,
      permissionEnum: PERMISSION_CONSTS,
      mxRecPermission: {
        name: RESOURCES.MAINTENANCE_REC,
        permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
      },
      aogPermission: {
        name: RESOURCES.AOG_FLEET_MANAGEMENT,
        permissionLevel: PERMISSION_LEVEL_CONSTS.EDIT,
      },
      fleetMonitoringPermission: {
        name: RESOURCES.FLEET_MONITORING,
        permissionLevel: PERMISSION_LEVEL_CONSTS.EDIT,
      },
      maintenanceData: {
        name: RESOURCES.REPEATER_ISSUE,
        permissionLevel: PERMISSION_LEVEL_CONSTS.READ,
      },
      collinsLogo,
      rotorLogo,
    }
  },

  computed: {
    aogOn() {
      let valOn = false
      if (this.featureFlags && 'FaultCodeManagement' in this.featureFlags) {
        valOn = this.featureFlags['FaultCodeManagement']
      }
      return valOn
    },
    fleetMonitoringOn() {
      let valOn = false
      if (this.featureFlags && 'FleetMonitoring' in this.featureFlags) {
        valOn = this.featureFlags['FleetMonitoring']
      }
      return valOn
    },
    getHighLightColor() {
      return variables.gray800
    },
    analyticsActive() {
      return this.analyticRoutes.find(item => item == this.$route.path)
    },
    analyticsGroupMatchRegex() {
      const regexString = `^(${this.analyticRoutes
        .map(str => `(${str})`)
        .join('|')})$`
      return new RegExp(regexString)
    },
    hasFaultcodeAdminPermission() {
      return this.userPermissions.some(
        up => up.name === RESOURCES.FAULT_CODE_ADMIN,
      )
    },
  },

  watch: {
    collapsed(newValue) {
      this.isCollapsed = newValue
      this.index = ''
    },
  },

  methods: {
    handleVue3Click(url) {
      window.location.replace(url)
    },
    createExternalRoute(route) {
      const protocol = window.location.protocol
      const mainPath = window.location.hostname

      let fullAddress = `${mainPath}/${process.env.BASE_URL}vue3/${route}`
      fullAddress = fullAddress.replace('//', '/')
      fullAddress = `${protocol}//${fullAddress}`

      if (process.env.VUE_APP_VUE3_URL) {
        fullAddress = `${process.env.BASE_URL}/${route}`
        fullAddress = fullAddress.replace('//', '/')
        fullAddress = `${process.env.VUE_APP_VUE3_URL}${fullAddress}`
      }
      return fullAddress
    },
    handleChange(index) {
      this.index = index
    },
    handleMiniVariantUpdate(value) {
      this.isCollapsed = value
      // this.onSizeChange(this.isCollapsed)
    },
    validatePermissions(permissions) {
      if (!permissions) {
        return true
      }

      let permissionSatisfied = false

      for (const permission of permissions) {
        if (
          this.userPermissions.find(
            item =>
              item.name == permission.name &&
              this.verifyLevel(
                item.permissionLevel,
                permission.permissionLevel,
              ),
          )
        ) {
          permissionSatisfied = true
          break
        }
      }
      return permissionSatisfied
    },
    validateRoles(roles) {
      if (!roles) {
        return true
      }

      for (const role of roles) {
        // If the AnserUser role then check for tiers
        if (role.name === 'AnserUser') {
          return (
            this.userRoles.find(item => item.name == role.name) &&
            this.userAirlines.length &&
            this.hasAnserToolPermissions(this.userAirlines)
          )
        }
        if (this.userRoles.find(item => item.name == role.name)) {
          return true
        }
      }

      return false
    },
    verifyLevel(userLevel, requiredLevel) {
      if (userLevel < requiredLevel) {
        return false
      }

      //Anything > 4 has to have delete
      if (requiredLevel === PLC.DELETE) {
        return userLevel >= PLC.DELETE
      }

      //Edit gets weird because 5 is a valid number.
      //Subtract the 4 to remove 5 from the equation and anything > 2 must be fine.
      if (requiredLevel === PLC.EDIT) {
        let tempLevel = userLevel
        if (userLevel >= 4) {
          tempLevel -= 4
        }
        return tempLevel >= PLC.EDIT
      }

      //Read will always be odd
      return userLevel % 2 === PLC.READ
    },
    hasAnserToolPermissions(userAirlines) {
      return userAirlines.some(airline => {
        return [
          FULL_FLIGHT_TIER_2,
          COLLINS_PHM_TIER_3,
          COLLINS_PHM_TIER_4,
        ].some(tierId => airline.phmAgreementTypes.includes(tierId))
      })
    },
  },
}
</script>

<style lang="scss">
.asc-primary-navbar--container {
  background-color: $gray-1000 !important;

  .asc-primary-navbar--gear-logo-container {
    height: 51px;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: $primary-black !important;

    .asc-primary-navbar--gear {
      margin: 0 10px 0 10px;
      fill: $primary-white;
      width: 30px;
      height: auto;
      overflow: visible;
    }

    .asc-primary-navbar--logo {
      margin: 0 10px 0 10px;
      fill: $primary-white;
      overflow: visible;
      width: auto;
      height: 30px;
    }
  }

  .asc-nav-list {
    .v-list-group__items > .asc-nav-list-item {
      padding-left: 50px !important;
    }

    .asc-nav-list-item,
    .v-list-group > .v-list-group__header {
      color: $gray-300 !important;

      &--active,
      &.v-list-item--active {
        color: $primary-white !important;

        &:not(:hover):not(:focus):before {
          opacity: 0.24;
        }
      }

      & .legacy_text {
        text-transform: none;
        font-style: italic;
      }
    }

    .v-list-item__icon {
      min-width: 18px;

      .v-icon {
        color: inherit;
        font-size: 18px;
      }

      &:not(.v-list-group__header__append-icon) {
        margin-right: 15px !important;
      }

      &.v-list-group__header__append-icon {
        .v-icon {
          color: inherit;
          font-size: 16px !important;
        }
      }
    }

    &--collapsed {
      .v-list-item__icon {
        &:not(.v-list-group__header__append-icon) {
          margin-right: 5px !important;
        }
      }
    }
  }
}
</style>
